/**
 * Sprint 23.8 — WorkspaceHomeSidebar.
 *
 * Composes the 4 sidebar blocks (Workspace info · Workforce health · Connections
 * · Recent activity) as divided sections via `<SidebarBlock>`. The first block
 * owns `isFirst` (no top divider); each block reads its own slice of the shared
 * overview / activity queries.
 */

import { WorkspaceInfoBlock } from "./WorkspaceInfoBlock";
import { WorkforceHealthBlock } from "./WorkforceHealthBlock";
import { ConnectionsSummaryBlock } from "./ConnectionsSummaryBlock";
import { RecentActivityBlock } from "./RecentActivityBlock";

export function WorkspaceHomeSidebar() {
  return (
    <>
      <WorkspaceInfoBlock />
      <WorkforceHealthBlock />
      <ConnectionsSummaryBlock />
      <RecentActivityBlock />
    </>
  );
}
